<template>
  <div class="problem-type">
    <div class="little-tip">问题类型</div>
    <div class="problem-type-right-top">
      <el-button type="primary" @click="handleAdd">新增</el-button>
      <el-popover placement="bottom" width="160" v-model="visible">
        <el-checkbox-group v-model="checkList">
          <el-checkbox v-for="(item, i) in tableHeaderList" @change="handleChangeCheckBox" :label="item.label" :key="i"></el-checkbox>
        </el-checkbox-group>
        <i slot="reference" class="problem-type-screen-btn" />
      </el-popover>
    </div>
    <div class="problem-type-right-table">
      <el-table stripe :data="tableData" border style="width: 100%" height="100%">
        <el-table-column type="selection" width="36"></el-table-column>
        <el-table-column v-if="tableHeaderList[0].status" prop="problem_type" label="问题类型"></el-table-column>
        <el-table-column v-if="tableHeaderList[3].status" prop="rank" label="优先级"></el-table-column>
        <el-table-column v-if="tableHeaderList[1].status" prop="is_show" label="是否展示">
          <template slot-scope="scope">
            {{ scope.row.is_show === 1 ? '显示' : '不显示' }}
          </template>
        </el-table-column>
        <el-table-column v-if="tableHeaderList[2].status" prop="create_time" label="添加时间"></el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <span class="problem-type-table-icon" @click="handleUpt(scope.row)">修改</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-sizes="[50, 100, 200, 500]"
      :page-size="limit"
      layout="prev, pager, next, jumper, total, sizes"
      :total="count">
    </el-pagination>
    <el-dialog
      :visible.sync="dialogVisible"
      width="35%"
      :show-close="false"
      :before-close="handleClose">
      <template slot="title">
        <el-divider content-position="left">{{ dialogTitle }}</el-divider>
      </template>
      <el-form ref="form" :rules="rules" :model="form" label-width="80px">
        <el-form-item label="问题类型" prop="problem_type">
          <el-input v-model="form.problem_type"></el-input>
        </el-form-item>
        <el-form-item label="应用角色" prop="type">
          <div class="diy-suffix">
            <el-select id="form_type" v-model="form.type" placeholder="请选择">
              <el-option v-for="item in typeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
            <i class="iconfont icon-xiajiantou diy-suffix-icon" @click="handleFouceSelect('form_type')" />
          </div>
        </el-form-item>
        <el-form-item label="是否显示" prop="is_show">
          <div class="diy-suffix">
            <el-select id="form_is_show" v-model="form.is_show" placeholder="请选择">
              <el-option v-for="item in isShowList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
            <i class="iconfont icon-xiajiantou diy-suffix-icon" @click="handleFouceSelect('form_is_show')" />
          </div>
        </el-form-item>
        <el-form-item label="优先级" prop="rank">
          <el-input v-model="form.rank"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { GetProblemList, PostProblemAdd, PostProblemEdit } from '../../api/problem'
export default {
  data () {
    var validateProblemRank = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入优先级'))
      }
      if ('' + value.length > 4) {
        return callback(new Error('超出最大输入长度4位'))
      }
      var reg = /^[0-9]{0,4}$/
      if (!reg.test(value)) {
        callback(new Error('请输入数字，最小为0'))
      } else {
        callback()
      }
    }
    return {
      visible: false,
      dialogTitle: '新增问题类型',
      dialogVisible: false,
      page: 1,
      limit: 100,
      count: 0,
      form: {},
      tableHeaderList: [
        { label: '问题类型', status: true },
        { label: '是否展示', status: true },
        { label: '添加时间', status: true },
        { label: '优先级', status: true }
      ],
      isShowList: [
        { value: 1, label: '显示' },
        { value: 2, label: '不显示' }
      ],
      typeList: [
        { value: 1, label: '客户' },
        { value: 2, label: '下家' },
        { value: 3, label: '全部' }
      ],
      tableData: [],
      rules: {
        problem_type: [
          { required: true, message: '请输入问题类型', trigger: 'blur' },
          { max: 255, message: '超出最大输入长度255个字符', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择应用角色', trigger: 'change' }
        ],
        is_show: [
          { required: true, message: '请选择是否显示', trigger: 'change' }
        ],
        rank: [
          { required: true, validator: validateProblemRank, trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    checkList: {
      get () {
        return this.tableHeaderList.filter(v => v.status).map(v => v.label)
      },
      set (newVal) {
        for (let i = 0; i < this.tableHeaderList.length; i++) {
          this.tableHeaderList.status = newVal
        }
      }
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      const { page, limit } = this
      const params = {
        page,
        limit
      }
      GetProblemList(params).then(res => {
        if (res) {
          const { count, data } = res
          this.tableData = data
          this.count = count
        }
      })
    },
    handleAdd () {
      this.dialogTitle = '新增问题类型'
      this.dialogVisible = true
    },
    handleUpt (row) {
      this.form = { ...row }
      this.dialogTitle = '修改问题类型'
      this.dialogVisible = true
    },
    handleSubmit () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const url = this.dialogTitle === '新增问题类型' ? PostProblemAdd : PostProblemEdit
          const params = { ...this.form }
          url(params).then(res => {
            if (res) {
              this.$message.success(res.msg)
              this.dialogVisible = false
              this.init()
            }
          })
        }
      })
    },
    handleChangeCheckBox (value, e) {
      for (let i = 0; i < this.tableHeaderList.length; i++) {
        if (this.tableHeaderList[i].label === e.target.defaultValue) {
          this.tableHeaderList[i].status = value
        }
      }
    },
    handleFouceSelect (val) {
      document.getElementById(val).click()
    },
    handleClose () {
      this.form = {}
      this.$refs.form.resetFields()
      this.dialogVisible = false
    },
    handleSizeChange (val) {
      this.limit = val
      this.init()
    },
    handleCurrentChange (val) {
      this.page = val
      this.init()
    }
  }
}
</script>

<style lang="less">
.problem-type {
  position: relative;
  height: calc(100% - 130px);
  margin: 30px 20px 40px 20px;
  display: flex;
  flex-direction: column;
  background: #fff;
  box-shadow: 0px 1px 6px 1px rgba(34, 82, 177, 0.07);
  padding: 15px 12px;
  width: 1180px;
  margin: 30px auto;
  .el-dialog__header {
    padding: 0;
    padding-top: 10px;
    .el-divider__text {
      color: #02044A;
      font-size: 22px;
      padding: 0 15px;
    }
  }
  .el-dialog__body {
    padding: 10px 20px;
  }
  .el-dialog__footer {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 0;
    padding-bottom: 40px;
    .el-button {
      padding: 12px 60px;
      font-size: 18px;
      letter-spacing: 4px;
    }
    .el-button+.el-button {
      margin-left: 40px;
    }
    .el-button--primary {
      background: #0C75FF;
    }
    .el-button--default {
      background: #DDDDDD;
      color: #676767;
    }
  }
  .el-table td, .el-table th {
    text-align: center;
  }
  .little-tip {
    position: absolute;
    color: #e0e0e0;
    font-size: 14px;
    top: -26px;
    left: 0;
  }
  .problem-type-right-top {
    height: 40px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 12px;
    .problem-type-screen-btn {
      display: inline-block;
      width: 40px;
      height: 40px;
      background: url('../../assets/img/screen-noselect-btn.png') no-repeat;
      background-size: 100% 100%;
    }
    .el-button {
      height: 40px;
      padding: 10px 36px;
      font-size: 16px;
      background-color: #8FB98A;
      border-color: #8FB98A;
      letter-spacing: 4px;
    }
  }
  .problem-type-right-table {
    width: 100%;
    height: calc(100% - 94px);
    overflow: hidden;
    margin-bottom: 10px;
    border-right: 1px solid #CCCCD8;
    border-bottom: 1px solid #CCCCD8;
    .problem-type-table-icon {
      margin: 0 5px;
      cursor: pointer;
    }
    .el-table {
      height: 100%;
      border-color: #CCCCD8;
      th {
        color: #02044A;
        background: #E8EEF6;
        border-color: #CCCCD8;
        font-weight: normal;
      }
      td {
        color: #74758F;
        border-color: #CCCCD8;
      }
      .el-table-column--selection .cell {
        padding-right: 10px;
      }
    }
  }
  .gongneng-icon {
    display: inline-block;
    width: 20px;
    height: 20px;
    margin-right: 5px;
    background-size: 100% 100%;
    transform: translateY(3px);
  }
  .car-icon {
    background-image: url('../../assets/img/car.png');
  }
  .message-icon {
    background-image: url('../../assets/img/message.png');
  }
  .delete-icon {
    background-image: url('../../assets/img/delete.png');
    margin-right: 0;
  }
  .el-pagination__total {
    margin-left: 10px;
  }
  .el-form {
    display: flex;
    flex-wrap: wrap;
    .el-form-item {
      width: calc(50% - 5px);
      margin-right: 10px;
      border: 1px solid #DDDDE6;
      border-radius: 4px;
      .el-input__inner {
        border: 0;
      }
      .el-input {
        margin-left: 10px;
        width: calc(100% - 10px);
      }
      .el-select {
        width: 100%;
      }
      &:nth-child(2n) {
        margin-right: 0;
      }
      .el-form-item__label {
        border: 0;
        background: #F0F1F4;
        color: #6E6F95;
        font-size: 14px;
        text-align: center;
        padding-right: 0;
        height: 41px;
        border-right: 1px solid #DDDDE6;
      }
    }
    .diy-suffix {
      position: relative;
      .diy-suffix-icon {
        position: absolute;
        right: 7px;
        top: 2px;
        cursor: pointer;
      }
    }
    .el-input__suffix {
      display: none;
    }
  }
}
</style>
